/**
 * ImportUsers
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import Breadcrumbs from 'components/layout/Breadcrumbs/index.jsx';
import ImportSheet from 'components/interaction/ImportSheet/index.jsx';
import MatchColumns from 'components/interaction/ImportSheet/MatchColumns.jsx';
import { intlLink } from 'utils/intlFunctions.jsx';
import messages from './messages.js';

const typeData = {
  employee: {
    title: messages.importEmployees,
    columns: messages.importEmployeesFields,
    template: 'https://socialschoolsadmin-test.azurewebsites.net/Content/Templates/Template_importeren_medewerkers.xlsx',
  },
};

function ImportUsers(props) {
  const { setMeta } = props;
  const { id: roleId } = useParams();
  const roleType = roleId.replace(/Mail$/, '');
  const [data, setData] = useState();
  const intl = useIntl();
  const { title, columns, template } = typeData[roleId];
  const parts = [
    { href: `/admin/users#${roleType}`, label: messages.users },
    { label: title },
  ];
  useEffect(() => {
    setMeta({
      title,
      header: <Breadcrumbs parts={parts} />,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fields = intl.formatMessage(columns).split('|');
  const hasColumns = data && data.sheetData && data.sheetData.fields;
  // console.log('Import Sheet', data);
  return (
    <Card className="p-4">
      <h2 className="card-title mt-0"><FormattedMessage {...messages.selectFile} /></h2>
      <p><FormattedMessage {...messages.selectFileIntro} values={intlLink(template)} /></p>
      <ul>
        {fields.map((fld) => <li key={fld}>{fld}</li>)}
      </ul>
      <div className="py-3">
        <ImportSheet onChange={setData} />
      </div>
      {hasColumns && (
        <MatchColumns fields={fields} columns={data.sheetData.fields} />
      )}
    </Card>
  );
}

ImportUsers.propTypes = {
  setMeta: PropTypes.func,
};

export default ImportUsers;
